import { IContentTemplate } from "../interfaces/content/content-template.model.interface";
import { IContentType } from "../interfaces/content/content-type-model.interface";
import { IState } from "../interfaces/config/state.model.interface";
import { StatusType } from "../../enums/StatusType";
import { State } from "../config/state.model";
import { ContentTypeModel } from "@/models/content/content-type-model";
import { IContentScenarioType } from "../interfaces/content/content-scenario-type.model.interface";
import { ContentScenarioTypeModel } from "./content-scenario-type-model";
import { ICampaignDeliveryType } from "../interfaces/campaign/campaign-delivery-type.model.interface";
import { CampaignDeliveryTypeModel } from "../campaign/campaign-delivery-type-model";

export class ContentTemplateModel implements IContentTemplate {
    public templateId: number;
    public name: string;
    public description: string;
    public createdDate: Date;
    public template: string;
    public contentType: IContentType;
    public state: IState;
    public contentScenarioType: IContentScenarioType;
    public campaignDeliveryTypes: ICampaignDeliveryType[];

    constructor() {
        this.templateId = 0;
        this.name = "";
        this.description = "";
        this.createdDate = new Date();
        this.template = "";
        this.contentType = new ContentTypeModel();
        this.state = new State(StatusType.Configure, "Configure");
        this.contentScenarioType = new ContentScenarioTypeModel();
        this.campaignDeliveryTypes = [new CampaignDeliveryTypeModel(1, "Lead Generation")];
    }
}
